
import dayjs from 'dayjs';
import i18n from 'i18next';
import { isLooseEqual } from '@app/utils/equality';


// 날짜 형태 변환
export function dayFormat(date, type) {
  return dayjs(date).format(type);
}

//전화번호 포맷
export function phoneFormatter(value) {
  if (!value) {
    return '';
  }

  value = value.replace(/[^0-9]/g, '');

  let result = [];
  let restNumber = '';

  // 지역번호와 나머지 번호로 나누기
  if (value.startsWith('02')) {
    // 서울 02 지역번호
    result.push(value.substr(0, 2));
    restNumber = value.substring(2);
  } else if (value.startsWith('1')) {
    // 지역 번호가 없는 경우
    // 1xxx-yyyy
    restNumber = value;
  } else {
    // 나머지 3자리 지역번호
    // 0xx-yyyy-zzzz
    result.push(value.substr(0, 3));
    restNumber = value.substring(3);
  }

  if (restNumber.length === 7) {
    // 7자리만 남았을 때는 xxx-yyyy
    result.push(restNumber.substring(0, 3));
    result.push(restNumber.substring(3));
  } else {
    result.push(restNumber.substring(0, 4));
    result.push(restNumber.substring(4));
  }

  return result.filter((val) => val).join('-');
}

export function businessNumberFormatter(num, type) {
  var formatNum = '';

  if (isLooseEqual(type, 0)) {
    formatNum = num?.replace(/(\d{3})(\d{2})(\d{5})/, '$1-$2-*****');
  } else {
    formatNum = num?.replace(/(\d{3})(\d{2})(\d{5})/, '$1-$2-$3');
  }

  return formatNum;
}

export const toObject = (arr) => {
  const obj = {};
  arr.forEach((item, i) => {
    obj[item.name] = item.value;
  });
  return obj;
};

//데이트값 시간으로 변환
export function dateTimeFormat(date, isEnglish) {
  const t = i18n.t.bind(i18n);
  // 날짜 -> 시간으로 변환
  let hour = null,
    minute = null,
    timeType = null;

  if (!date) return;
  hour = dayjs(date).format('HH');
  minute = dayjs(date).format('mm');

  if (parseInt(hour) >= 12) {
    if (hour !== 12) {
      hour = hour - 12 || 12;
    }

    timeType = isEnglish ? 'PM ' : t('date:오후') + ' ';
  } else {
    timeType = isEnglish ? 'AM ' : t('date:오전') + ' ';
  }

  return timeType + hour + ':' + minute;
}

// 날짜 요일 변환
export function weekFormat(day, localeType = 'date') {
  const t = i18n.t.bind(i18n);
  let dayValue;
  if (typeof day === 'number') {
    dayValue = day;
  } else {
    dayValue = dayjs(day).day();
  }

  switch (dayValue) {
    case 1:
      return t(`${localeType}:월`);
    case 2:
      return t(`${localeType}:화`);
    case 3:
      return t(`${localeType}:수`);
    case 4:
      return t(`${localeType}:목`);
    case 5:
      return t(`${localeType}:금`);
    case 6:
      return t(`${localeType}:토`);
    case 7:
    case 0:
      return t(`${localeType}:일`);
    default:
      break;
  }
}

// 숫자 포맷
export function onlyNumber(value) {
  if (!value) return;
  return value.replace(/[^0-9]/gi, '');
}

//오브젝트의 키값을 이름순으로 정렬
export function objectKeySort(object) {
  return Object.keys(object)
    .sort()
    .reduce((newObj, key) => {
      newObj[key] = object[key];
      return newObj;
    }, {});
}

// 천단위 구분
export function commaOfNumber(number) {
  if (number == null) return '';
  var string = '' + number; // 문자로 바꾸기.

  string = string.replace(/[^-+.\d]/g, ''); // ±기호와 소수점, 숫자들만 남기고 전부 지우기.

  var regExp = /^([-+]?\d+)(\d{3})(\.\d+)?/; // 필요한 정규식.

  while (regExp.test(string))
    string = string.replace(regExp, '$1,$2$3'); // 쉼표 삽입.

  return string;
}

export function getColumnsTotalWidth(columns) {
  return (
    columns?.reduce((acc, obj) => {
      return acc?.width + (obj?.width || 0);
    }, 0) || 0
  );
}
